import { SvgIcon } from '@mui/material'

export const DeleteIcon = ({ color = 'inherit', ...props }) => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 3.00012V4.00012H20V6.00012H19V19.0001C19 20.1001 18.1 21.0001 17 21.0001H7C5.9 21.0001 5 20.1001 5 19.0001V6.00012H4V4.00012H9V3.00012H15ZM7 19.0001H17V6.00012H7V19.0001ZM9 8.00012H11V17.0001H9V8.00012ZM15 8.00012H13V17.0001H15V8.00012Z"
      fill={color}
    />
  </SvgIcon>
)
